import React, { Suspense, lazy } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "./css/App.css";
import PrivateRoute from "./Routes/PrivateRoute";
import { Toaster } from "react-hot-toast";
import MaveraLoading from "./image/MaveraLoading.svg";
import { ConfirmProvider } from "./components/ConfirmDialog";
import { TooltipProvider } from "./components/ui/tooltip";

// DEV koşulu production build sırasında katalog importunu kaldırır.
const UiKatalog = import.meta.env.DEV ? lazy(() => import("./component/UiKatalog")) : null;

// Lazy-loaded pages
const Yeni = lazy(() => import("./component/yeni"));
const Ayarlar = lazy(() => import("./component/Settings/Ayarlar"));
const Dashboard = lazy(() => import("./component/Dashboard/Dashboard"));
const PageNotFound = lazy(() => import("./component/yeni/PageNotFound"));
const Bagiscilar = lazy(() => import("./component/Bagiscilar"));
const Mali = lazy(() => import("./component/Mali"));
const Home = lazy(() => import("./component/Home/Home"));
const Performans = lazy(() => import("./component/Performans/Performans"));
const Yonetim = lazy(() => import("./component/Yonetim/Yonetim"));
const Login = lazy(() => import("./component/Login/Login"));
// Proje Ortagi yukleme sayfasi. 01.10.2026'da KORUMALI hale getirildi:
// sifresiz link kaldirildi, giris sart. Bkz. middlewares/ortak_link.js
const OrtakSayfa = lazy(() => import("./component/Ortak/OrtakSayfa"));
const Mutabakat = lazy(() => import("./component/Mutabakat/Mutabakat"));
const RefDashboard = lazy(() =>
  import("./component/Home/IkinciReferans/RefDashboard")
);
const ProjeYonetimi = lazy(() => import("./component/ProjeYonetimi"));

function App(props) {
  return (
    <TooltipProvider delayDuration={200}>
    <ConfirmProvider>
    <div className="App">
      {/* <NavbarPage/> */}
      <div>
        <Toaster position="top-center" />
      </div>
      <BrowserRouter>
        <Suspense
          fallback={
            <div className="xy">
              <img alt="loading" src={MaveraLoading} />
            </div>
          }
        >
          <Routes>
            <Route path="/" element={<Login {...props} />} />
            {import.meta.env.DEV && <Route path="/ui-katalog" element={<UiKatalog />} />}

            <Route element={<PrivateRoute />}>
              {/* Ortak yukleme sayfasi. ARTIK KORUMALI: sifresiz link kaldirildi. */}
              <Route path="/ortak" element={<OrtakSayfa />} />
              {/* Menuden gelen yol: sidebar linkleri /projeId/<id> kalibinda. */}
              <Route path="/projeId/ortak" element={<OrtakSayfa />} />
              <Route
                path="/projeId/ayarlar"
                element={<Navigate to="/projeId/ayarlar/1" />}
              />
              <Route path="/projeId/ayarlar/:tabId" element={<Ayarlar />} />
              <Route path="/projeId/dashboard" element={<Dashboard />} />
              <Route path="/projeId/bagiscilar" element={<Bagiscilar />} />
              <Route
                path="/projeId/mali"
                element={<Navigate to="/projeId/mali/1" />}
              />
              <Route path="/projeId/mali/:tabId" element={<Mali />} />

              <Route path="/projeId/home" element={<Home />} />
              <Route path="/projeId/performans" element={<Performans />} />
              <Route path="/projeId/yonetim" element={<Yonetim />} />
              <Route path="/projeId/mutabakat" element={<Mutabakat />} />
              <Route
                path="/projeId/home/ikinciRefDetay"
                element={<RefDashboard />}
              />
              <Route
                path="/projeId/proje-yonetimi"
                element={<ProjeYonetimi />}
              />
              <Route path="/projeId/:id" element={<Yeni />} />
              <Route path="*" element={<PageNotFound />} />
            </Route>
            <Route path="*" element={<PageNotFound tamEkran />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
    </ConfirmProvider>
    </TooltipProvider>
  );
}

export default App;
